{
  "checkedInTitle": "ਤੁਸੀਂ ਚੈੱਕ-ਇਨ ਹੋ ਗਏ ਹੋ",
  "postCheckInInstructions": "ਚੈੱਕ-ਇਨ ਤੋਂ ਬਾਅਦ ਦੀਆਂ ਹਦਾਇਤਾਂ",
  "appointmentDetails": "ਮੁਲਾਕਾਤ ਦੇ ਵੇਰਵੇ",
  "notifyWarehouse": "ਅਸੀਂ ਗੁਦਾਮ ਨੂੰ ਦੱਸ ਦਿੱਤਾ ਹੈ ਕਿ ਤੁਸੀਂ ਪਹੁੰਚ ਗਏ ਹੋ ਤਾਂ ਜੋ ਉਹ ਆਪਣੀ ਉਪਲਬਧਤਾ ਦੀ ਜਾਂਚ ਕਰ ਸਕਣ",
  "waitForStaff": "ਕਿਰਪਾ ਕਰਕੇ ਗੁਦਾਮ ਦੇ ਸਟਾਫ ਵੱਲੋਂ ਹੋਰ ਹਦਾਇਤਾਂ ਦੀ ਉਡੀਕ ਕਰੋ",
  "unplannedDescription": "ਜਾਪਦਾ ਹੈ ਕਿ ਤੁਹਾਡੀ ਕੋਈ ਮੁਲਾਕਾਤ ਨਹੀਂ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਗੁਦਾਮ ਦੇ ਸਟਾਫ ਵੱਲੋਂ ਹੋਰ ਹਦਾਇਤਾਂ ਦੀ ਉਡੀਕ ਕਰੋ।",
  "whatsappDelay": "ਪਹਿਲਾ ਵਟਸਐਪ ਸੁਨੇਹਾ ਪਹੁੰਚਣ ਵਿੱਚ ਇੱਕ ਮਿੰਟ ਤੱਕ ਦਾ ਸਮਾਂ ਲੱਗ ਸਕਦਾ ਹੈ।",
  "bookNextTitle": "ਅਗਲੀ ਵਾਰ ਲਈ ਮੁਲਾਕਾਤ ਬੁੱਕ ਕਰੋ",
  "bookNextBody": "Opendock ਵਿੱਚ ਰਜਿਸਟਰ ਕਰੋ ਤਾਂ ਜੋ ਤੁਸੀਂ ਅਗਲੀ ਵਾਰ ਇਸ ਸਹੂਲਤ 'ਤੇ ਆਉਣ 'ਤੇ ਮੁਲਾਕਾਤ ਬੁੱਕ ਕਰ ਸਕੋ",
  "helpFooter": "ਜੇ ਤੁਹਾਨੂੰ ਕਿਸੇ ਵੀ ਮਦਦ ਜਾਂ ਵਾਧੂ ਜਾਣਕਾਰੀ ਦੀ ਲੋੜ ਹੈ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਗੁਦਾਮ ਦੇ ਸਟਾਫ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
  "finalize": "ਅੰਤਿਮ ਰੂਪ ਦਿਓ ({seconds})"
}
